import {
  useCurrentUser,
  useTenant,
} from "~frontend/providers/LoggedInUserProvider";
import { useSubaccount } from "~frontend/providers/SubaccountProvider";

export function useStaffCsvFilenameValidator({
  orgWide,
}: { orgWide?: boolean } = {}): (
  filename: string
) => { valid: true } | { valid: false; errorMessage: string } {
  const tenant = useTenant();
  const subaccountInfo = useSubaccount();
  const user = useCurrentUser();

  if (!user || !tenant) {
    return () => ({ valid: true });
  }

  const userHasStwEmail =
    user.email.endsWith("@scaletowin.com") ||
    user.email.endsWith("@contractors.scaletowin.com");

  if (!userHasStwEmail) {
    return () => ({ valid: true });
  }

  const csvFilenameValidationPrefixes = orgWide
    ? [`${tenant.slug}-org-`]
    : tenant.subaccountsEnabled && subaccountInfo && subaccountInfo.subaccount
      ? [
          `${tenant.slug}-${subaccountInfo.subaccount.slug}-`,
          `${tenant.slug}-shared-`,
        ]
      : [`${tenant.slug}-`];

  return (filename: string) => {
    if (
      csvFilenameValidationPrefixes.some(prefix =>
        filename.toLowerCase().startsWith(prefix.toLowerCase())
      )
    ) {
      return { valid: true };
    }

    return {
      valid: false,
      errorMessage: `Expected filename to start with ${csvFilenameValidationPrefixes.map(prefix => `"${prefix}"`).join(" or ")}`,
    };
  };
}
